///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Model } from "@inweb/client";
import { IOptions } from "@inweb/viewer-core";

import { TCSLoader } from "./TCSLoader";
import { VsfXLoader } from "./VsfXLoader";
import { VsfXStreamingLoader } from "./VsfXStreamingLoader";
import { VsfXPartialLoader } from "./VsfXPartialLoader";
import { Viewer } from "../Viewer";

export class LoaderFactory {
  create(viewer: Viewer, model: Model, options: IOptions) {
    const geometryType = model.database.split(".").pop();

    if (model.geometry.length === 0 && geometryType === "vsfx") {
      if (!options.enableStreamingMode) return new VsfXLoader(viewer, model, options);
      else if (options.enablePartialMode) return new VsfXPartialLoader(viewer, model, options);
      else return new VsfXStreamingLoader(viewer, model, options);
    }

    if (geometryType === "data") {
      return new TCSLoader(viewer, model, options);
    }

    throw new Error(`Unknown geometry type: ${geometryType}`);
  }
}
